(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  /* =========================================================
     PRODUCT CARD VARIANTS + AJAX ADD TO CART
     Extracted working logic adapted for collection cards

     NEW: jo variant select hota hai, card ki asal price bhi
     usi variant ki price dikhati hai (sale price + compare at
     price ke sath). Selection hatne par theme ki original
     price wapas aa jati hai.
  ========================================================= */

  class ProductCardVariants extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.variants = this.readVariants();
      this.optionCount = parseInt(this.dataset.optionCount || '1', 10);
      this.selections = new Array(this.optionCount).fill(null);

      this.buttons = Array.from(this.querySelectorAll('[data-option-value]'));
      this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
      this.atcButton = this.querySelector('[data-atc]');
      this.priceEl = this.querySelector('[data-selected-price]');
      this.errorEl = this.querySelector('[data-atc-error]');

      /* Theme ka apna price element (card ke andar) */
      this.cardPriceEl = this.resolveCardPriceEl();
      this.cardPriceOriginal = this.cardPriceEl ? this.cardPriceEl.innerHTML : null;

      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.onSelect(button);
        });
      });

      this.moreButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleMore(button);
        });
      });

      if (this.atcButton) {
        this.atcButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.addToCart();
        });
      }

      this.preselect();
      this.update();
    }

    readVariants() {
      const script = this.querySelector('[data-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent) || [];
      } catch (e) {
        return [];
      }
    }

    hasButtonsAt(position) {
      return this.buttons.some(
        (button) => parseInt(button.dataset.optionPosition, 10) === position + 1
      );
    }

    toggleMore(button) {
      const row = button.closest('[data-option-row]');
      if (!row) return;

      const expanded = row.dataset.expanded === 'true';
      const hidden = Array.from(row.querySelectorAll('[data-extra="true"]'));

      hidden.forEach((item) => {
        item.dataset.hidden = expanded ? 'true' : 'false';
      });

      row.dataset.expanded = expanded ? 'false' : 'true';
      button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }

    preselect() {
      const first = this.variants.find((variant) => variant.available) || this.variants[0];
      if (!first) return;

      for (let index = 0; index < this.optionCount; index++) {
        const value = first.options[index];
        if (value === undefined) continue;

        if (!this.hasButtonsAt(index)) {
          this.selections[index] = value;
          continue;
        }

        const exists = this.buttons.some(
          (button) =>
            parseInt(button.dataset.optionPosition, 10) === index + 1 &&
            button.dataset.optionValue === value
        );

        if (exists) this.selections[index] = value;
      }
    }

    onSelect(button) {
      const position = parseInt(button.dataset.optionPosition, 10) - 1;
      const value = button.dataset.optionValue;

      this.selections[position] =
        this.selections[position] === value ? null : value;

      this.update(true);
    }

    matchedVariant() {
      if (this.variants.length === 1) return this.variants[0];

      if (this.selections.some((selection) => selection === null)) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          variant.options.every(
            (option, index) => option === this.selections[index]
          )
        ) || null
      );
    }

    valueIsAvailable(position, value) {
      return this.variants.some((variant) => {
        if (!variant.available) return false;
        if (variant.options[position] !== value) return false;

        return this.selections.every(
          (selection, index) =>
            index === position ||
            !selection ||
            variant.options[index] === selection
        );
      });
    }

    updateSelectedOptionLabels() {
      this.querySelectorAll('[data-option-row]').forEach((row) => {
        const label = row.querySelector('.card-variant-options__label');
        if (!label) return;
        const selected = row.querySelector('[data-option-value][aria-pressed="true"]');
        const optionName = label.dataset.optionName || label.textContent.trim();
        label.dataset.optionName = optionName;
        label.textContent = optionName + (selected ? ': ' + selected.dataset.optionValue : '');
      });
    }

    update(changeImage = false) {
      this.buttons.forEach((button) => {
        const position =
          parseInt(button.dataset.optionPosition, 10) - 1;
        const value = button.dataset.optionValue;
        const selected = this.selections[position] === value;

        button.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );

        button.dataset.unavailable = this.valueIsAvailable(
          position,
          value
        )
          ? 'false'
          : 'true';

        if (selected && button.dataset.hidden === 'true') {
          const row = button.closest('[data-option-row]');
          const moreButton = row
            ? row.querySelector('[data-more]')
            : null;

          if (moreButton) this.toggleMore(moreButton);
        }
      });

      this.updateSelectedOptionLabels();

      const variant = this.matchedVariant();

      if (this.priceEl) {
        this.priceEl.innerHTML = variant ? variant.price : '';
      }

      /* Card ki asal price selected variant ke sath badalti hai */
      this.updateCardPrice(variant);

      if (changeImage && variant && variant.image && this.buttons.length) {
        this.swapImage(variant.image);
      }

      if (this.atcButton) {
        const labels = {
          idle: this.atcButton.dataset.labelIdle,
          soldOut: this.atcButton.dataset.labelSoldOut,
          choose: this.atcButton.dataset.labelChoose
        };

        if (!variant) {
          this.atcButton.disabled = true;
          this.atcButton.textContent = labels.choose;
        } else if (!variant.available) {
          this.atcButton.disabled = true;
          this.atcButton.textContent = labels.soldOut;
        } else {
          this.atcButton.disabled = false;
          this.atcButton.textContent = labels.idle;
        }
      }

      this.hideError();
    }

    /* =========================================================
       SELECTED VARIANT PRICE

       Har theme ka price block alag markup deta hai, is liye
       card ke andar sab se pehla price-jaisa element dhoond kar
       usi ke andar likhte hain. Original HTML yaad rakha jata
       hai taake selection hatne par wapas aa sake.
    ========================================================= */

    resolveCardPriceEl() {
      const card = this.closest('.product-grid__item') || this.parentElement;
      if (!card) return null;

      const selectors = [
        '[data-testid="price"]',
        'product-price',
        '.price',
        '.product-price',
        '[class*="price"]'
      ];

      for (const selector of selectors) {
        const found = Array.from(card.querySelectorAll(selector)).find((el) => {
          if (el === this || this.contains(el)) return false;
          if (el.tagName === 'SCRIPT' || el.tagName === 'TEMPLATE' || el.tagName === 'STYLE') {
            return false;
          }
          return true;
        });

        if (found) return found;
      }

      return null;
    }

    updateCardPrice(variant) {
      if (this.dataset.syncPrice === 'false') return;

      if (!this.cardPriceEl) {
        this.cardPriceEl = this.resolveCardPriceEl();
        if (!this.cardPriceEl) return;
        this.cardPriceOriginal = this.cardPriceEl.innerHTML;
      }

      /* Mukammal selection nahi — theme ki original price wapas */
      if (!variant) {
        if (this.cardPriceOriginal != null) {
          this.cardPriceEl.innerHTML = this.cardPriceOriginal;
        }
        return;
      }

      const onSale =
        variant.compare_at_price &&
        Number(variant.compare_at_price_raw) > Number(variant.price_raw);

      let html =
        '<span class="card-price__current' +
        (onSale ? ' card-price__current--sale' : '') +
        '">' +
        variant.price +
        '</span>';

      if (onSale) {
        html +=
          '<span class="card-price__compare">' +
          variant.compare_at_price +
          '</span>';
      }

      this.cardPriceEl.innerHTML = html;
    }

    swapImage(url) {
      if (this.dataset.swapImage !== 'true') return;

      const card = this.closest('.product-grid__item');
      if (!card) return;

      const img = card.querySelector('img');
      if (!img) return;

      try {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      } catch (e) {
        /* no-op */
      }
    }

    showError(message) {
      if (!this.errorEl) return;

      this.errorEl.textContent = message;
      this.errorEl.dataset.visible = 'true';
    }

    hideError() {
      if (!this.errorEl) return;

      this.errorEl.dataset.visible = 'false';
    }

    async addToCart() {
      const variant = this.matchedVariant();

      if (!variant || !variant.available || !this.atcButton) {
        return;
      }

      const button = this.atcButton;
      const idleLabel = button.dataset.labelIdle;
      const root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        '/';

      button.dataset.state = 'loading';
      button.textContent = button.dataset.labelLoading;
      this.hideError();

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1
              }
            ]
          })
        });

        if (!response.ok) {
          const data = await response
            .json()
            .catch(() => ({}));

          throw new Error(
            data.description ||
              data.message ||
              'Could not add to cart'
          );
        }

        button.dataset.state = 'done';
        button.textContent = button.dataset.labelAdded;

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'product-card' }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true
          })
        );

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = root + 'cart';
          return;
        }

        if (this.dataset.afterAdd === 'drawer') {
          const drawer = document.querySelector(
            'cart-drawer, cart-drawer-component, #cart-drawer'
          );

          if (drawer) {
            if (typeof drawer.open === 'function') {
              drawer.open();
            } else if (typeof drawer.showModal === 'function') {
              drawer.showModal();
            }
          }
        }

        window.setTimeout(() => {
          button.dataset.state = 'idle';
          button.textContent = idleLabel;
        }, 1800);
      } catch (error) {
        button.dataset.state = 'idle';
        button.textContent = idleLabel;

        this.showError(
          error.message || 'Something went wrong'
        );
      }
    }
  }

  if (!customElements.get('product-card-variants')) {
    customElements.define(
      'product-card-variants',
      ProductCardVariants
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-balloon-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.pa-balloons:not([data-pa-motion-initialized])';

    const initialize = (scope = document) => {
      scope.querySelectorAll(selector).forEach((section) => {
        section.dataset.paMotionInitialized = 'true';

        const items = [
          section.querySelector('.pa-balloons__header'),
          section.querySelector('.pa-balloons__feature'),
          ...section.querySelectorAll('.pa-balloons__category'),
          section.querySelector('.pa-balloons__custom')
        ].filter(Boolean);

        items.forEach((item, index) => {
          item.style.setProperty('--pa-motion-delay', `${Math.min(index * 85, 425)}ms`);
        });

        section.classList.add('pa-motion-ready');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('pa-motion-visible'));
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('pa-motion-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

        items.forEach((item) => observer.observe(item));
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-celebration-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-pa-edit]').forEach((section) => {
        if (section.dataset.paEditInitialized === 'true') return;
        section.dataset.paEditInitialized = 'true';

        const track = section.querySelector('[data-pa-edit-track]');
        const previous = section.querySelector('[data-pa-edit-prev]');
        const next = section.querySelector('[data-pa-edit-next]');

        const updateControls = () => {
          if (!track || !previous || !next) return;
          const maximum = track.scrollWidth - track.clientWidth;
          previous.disabled = track.scrollLeft <= 3;
          next.disabled = track.scrollLeft >= maximum - 3;
        };

        const move = (direction) => {
          if (!track) return;
          const card = track.querySelector('.pa-celebration-edit__item');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };

        if (previous) previous.addEventListener('click', () => move(-1));
        if (next) next.addEventListener('click', () => move(1));
        if (track) track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });
        updateControls();

        if (section.dataset.paAnimate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          section.classList.add('is-visible');
          return;
        }

        section.classList.add('is-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });

        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-custom-theme-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-pa-custom-theme]').forEach((section) => {
        if (section.dataset.paInitialized === 'true') return;
        section.dataset.paInitialized = 'true';

        if (section.dataset.paAnimate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          section.classList.add('is-visible');
          return;
        }

        section.classList.add('is-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.16 });

        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-featured-occasions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.pa-featured-occasions');

    sections.forEach((section) => {
      const items = section.querySelectorAll('.pa-featured-occasions__reveal');

      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-occasion-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pa-occasion-navigation-v3')) {
    customElements.define('pa-occasion-navigation-v3', class extends HTMLElement {
      connectedCallback() {
        this.timer = setTimeout(() => this.start(), 0);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.controller?.abort();
        this.quickObserver?.disconnect();
        this.quickNav?.removeEventListener('click', this.onClick);
        this.quickNav?.remove();
        if (this.onQuickScroll) {
          document.removeEventListener('scroll', this.onQuickScroll, true);
          window.removeEventListener('resize', this.onQuickScroll);
        }
        if (this.quickFrame) cancelAnimationFrame(this.quickFrame);
        this.quickFrame = null;
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (this.onHistory) window.removeEventListener('popstate', this.onHistory);
        this.started = false;
        this.completeGrid = null;
      }

      start() {
        if (!this.isConnected || this.started) return;
        this.started = true;
        this.labels = JSON.parse(this.querySelector('[data-occasion-labels]').textContent);
        this.defaultRules = {"bundles": "bundle, package, budget deal, budget friendly deal, standard deal, premium deal, decoration deal, complete party set, complete decoration set, complete celebration set", "decorations": "backdrop, banner, bunting, table runner, runner, table cover, table sheet, tablecloth, table cloth, cake topper, cupcake topper, cupcake wrap, bottle label, welcome standee, table standee, floor standee, wall hanging, door hanging, hanging, spiral, swirl, milestone board, fact board, wall frame, welcome board, popcorn holder, popcorn box, plates, paper plate, cups, paper cup, placemat, place mat, straw tag, mini flag, napkin, tissue box, fairy light, curtain, menu card, food label, buffet label, centerpiece, centrepiece, letter box, poster, mithai topper, methai topper, table tent, tent card, place card, dessert pick, disposable plate, disposable cup", "props-giveaways": "photo prop, props, photobooth, photo booth, selfie frame, goody bag, goodie bag, goody box, goodie box, favor box, favour box, favor bag, favour bag, mithai box, methai box, sweet box, tin box, announcement box, distribution box, bid box, bidh box, jute pouch, pouch, thank you tag, sticker, chocolate wrap, gift wrapping, gift wrap, tote bag, certificate, gajra card, money envelope, eidi envelope, gift tag, song book, quiz, game card, keepsake, tabaruk packaging, distribution bag, packaging bag, giveaway packaging, corporate box, gift bag, gift box, ribbon, wish card, prayer mat, jai nimaz, jae namaz, jai namaz, jaenimaz, tasbeeh, attar, zam zam bottle, zamzam bottle", "wearables-balloons": "balloon, ballon, baloon, crown, cap, t shirt, tshirt, tee shirt, badge, wristband, wrist band, sash, sashes, headband, head band, hairband, hair band, bracelet, brooch, pin badge, bazu bandh, arm band, imam zamin, eye mask, face mask, mask"};
        this.rules = this.labels.groups.map(group => {
          const role = group.automaticGroup === 'infer' ? group.tag.replace(/^occasion-/, '') : group.automaticGroup;
          const words = group.keywords || this.defaultRules[role] || '';
          return { group, role, rules: this.compileRules(words), excludes: this.compileRules(group.exclude || '') };
        });
        this.designMode = this.dataset.designMode === 'true';
        this.hideEmpty = this.dataset.hideEmpty === 'true';
        this.embedded = JSON.parse(this.querySelector('[data-occasion-products]').textContent);
        this.status = this.querySelector('[role="status"]');
        this.retry = this.querySelector('.pa-occasion-nav__retry');
        this.onClick = event => this.handleClick(event);
        this.onHistory = () => this.schedule();
        this.addEventListener('click', this.onClick);
        this.setupQuickNav();
        window.addEventListener('popstate', this.onHistory);
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
        this.refresh();
      }


      setupQuickNav() {
        this.quickNav = this.querySelector('.pa-occasion-quick') || this.quickNav;
        if (!this.quickNav) return;
        this.quickLinks = Array.from(this.quickNav.querySelectorAll('[data-occasion-group]'));
        document.body.append(this.quickNav);
        this.quickNav.addEventListener('click', this.onClick);
        this.onQuickScroll = event => {
          if (event?.target === this.quickNav) return;
          this.requestQuickUpdate();
        };
        document.addEventListener('scroll', this.onQuickScroll, { capture: true, passive: true });
        window.addEventListener('resize', this.onQuickScroll, { passive: true });
        this.quickObserver = new MutationObserver(() => this.requestQuickUpdate());
        const header = document.querySelector('#header-component');
        if (header) this.quickObserver.observe(header, { attributes: true, attributeFilter: ['data-sticky-state', 'data-scroll-direction', 'sticky'] });
      }

      requestQuickUpdate() {
        if (!this.quickNav || this.quickFrame) return;
        this.quickFrame = requestAnimationFrame(() => {
          this.quickFrame = null;
          this.updateQuickNav();
        });
      }

      visibleHeaderBottom() {
        const header = document.querySelector('#header-component');
        if (!header || header.dataset.stickyState === 'idle') return 0;
        const box = header.getBoundingClientRect();
        const wrapper = header.closest('.header-section') || header;
        if (!['sticky', 'fixed'].includes(getComputedStyle(wrapper).position)) return 0;
        return box.top <= 1 && box.bottom > 0 ? Math.max(0, box.bottom) : 0;
      }

      updateQuickNav() {
        if (!this.quickNav) return;
        const grid = this.findGrid();
        if (this.hidden || this.hasAttribute('aria-busy') || !grid || this.completeGrid !== grid || !this.groupHeadings?.length) {
          this.quickNav.hidden = true;
          return;
        }
        const headerBottom = this.visibleHeaderBottom();
        const cardsBottom = this.querySelector('.pa-occasion-nav__cards').getBoundingClientRect().bottom;
        const gridBox = grid.getBoundingClientRect();
        const visible = cardsBottom <= headerBottom && gridBox.bottom > headerBottom + 96 && gridBox.top < window.innerHeight;
        this.quickNav.hidden = !visible;
        if (!visible) return;
        this.quickNav.style.top = `${Math.ceil(headerBottom)}px`;
        const threshold = headerBottom + this.quickNav.getBoundingClientRect().height + 32;
        let active = this.groupHeadings[0];
        for (const heading of this.groupHeadings) {
          if (heading.element.getBoundingClientRect().top <= threshold) active = heading;
          else break;
        }
        const inMoreProducts = this.moreHeading && this.moreHeading.getBoundingClientRect().top <= threshold;
        this.setCurrentGroup(inMoreProducts ? null : active.key);
      }

      setCurrentGroup(key) {
        for (const card of this.querySelectorAll('[data-occasion-group]')) {
          if (card.dataset.occasionGroup === key) card.setAttribute('aria-current', 'location');
          else card.removeAttribute('aria-current');
        }
        for (const link of this.quickLinks || []) {
          const selected = link.dataset.occasionGroup === key;
          const wasSelected = link.getAttribute('aria-current') === 'location';
          if (selected) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
          if (selected && !wasSelected && !this.quickNav.hidden) {
            const left = link.offsetLeft;
            const right = left + link.offsetWidth;
            if (left < this.quickNav.scrollLeft) this.quickNav.scrollLeft = Math.max(0, left - 8);
            else if (right > this.quickNav.scrollLeft + this.quickNav.clientWidth) this.quickNav.scrollLeft = right - this.quickNav.clientWidth + 8;
          }
        }
      }

      syncQuickNav() {
        if (!this.quickNav) return;
        for (const link of this.quickLinks) {
          const card = this.querySelector(`[data-occasion-group="${link.dataset.occasionGroup}"]`);
          link.hidden = !card || card.hidden;
        }
        this.groupHeadings = this.labels.groups.map(group => ({ key: group.key, element: document.getElementById(`${this.id}-${group.key}`) })).filter(group => group.element);
        this.moreHeading = document.getElementById(`${this.id}-more`);
        this.requestQuickUpdate();
      }

      normalize(value) {
        return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&(?:amp;)?/g, ' and ').replace(/[^a-z0-9\u0600-\u06ff]+/g, ' ').trim().replace(/\s+/g, ' ');
      }

      compileRules(value) {
        return String(value || '').split(/[,\n;]+/).map(word => this.normalize(word)).filter(Boolean).map(word => ({
          regex: new RegExp(`(?:^| )${word.replace(/ /g, ' +')}(?:s|es)?(?= |$)`),
          score: word.split(' ').length * 10
        }));
      }

      ruleScore(rules, text) {
        return rules.reduce((score, rule) => rule.regex.test(text) ? Math.max(score, rule.score) : score, 0);
      }

      classifyProduct(value) {
        const product = Array.isArray(value) ? { tags: value } : value || {};
        const tags = (product.tags || []).map(tag => String(tag).trim().toLowerCase());
        const override = this.labels.groups.find(group => group.tag.toLowerCase() === 'occasion-bundles' && tags.includes(group.tag.toLowerCase())) || this.labels.groups.find(group => group.tag && tags.includes(group.tag.toLowerCase()));
        if (override) return override;
        if (!this.labels.automatic) return null;
        const title = this.normalize(product.title);
        const type = this.normalize(product.type);
        const handle = this.normalize(product.handle);
        const candidates = this.rules.filter(item => item.role !== 'manual').map(item => {
          if (this.ruleScore(item.excludes, title)) return { ...item, score: 0 };
          const titleScore = this.ruleScore(item.rules, title);
          const typeScore = this.ruleScore(item.rules, type);
          const handleScore = !titleScore && !typeScore ? this.ruleScore(item.rules, handle) : 0;
          const specificity = Math.max(titleScore, typeScore, handleScore);
          const rolePriority = { 'wearables-balloons': 3, 'props-giveaways': 2, decorations: 1 }[item.role] || 0;
          return { ...item, score: specificity ? specificity * 10 + rolePriority + (typeScore > titleScore ? .5 : 0) : 0 };
        });
        const bundle = candidates.find(item => item.role === 'bundles' && item.score > 0);
        if (bundle) return bundle.group;
        candidates.sort((a, b) => b.score - a.score);
        return candidates[0]?.score > 0 ? candidates[0].group : null;
      }

      findGrid() {
        return document.querySelector('results-list .product-grid[data-testid="product-grid"]');
      }

      cards(grid) {
        return Array.from(grid.children).filter(node => node.matches('[data-product-id]'));
      }

      signature(grid) {
        return this.cards(grid).map(card => card.dataset.productId).join(',');
      }

      urlKey() {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.delete('page');
        return url.href;
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 100);
      }

      async fetchHTML(url, signal) {
        const response = await fetch(url, { credentials: 'same-origin', signal });
        if (!response.ok) throw new Error('Collection request failed');
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      }

      async loadMetadata(signal) {
        if (this.metadata) return this.metadata;
        let data = this.embedded;
        if (data.products.length !== data.total) {
          const url = new URL(this.dataset.collectionUrl, location.origin);
          for (const name of ['preview_theme_id', 'currency']) {
            const value = new URL(location.href).searchParams.get(name);
            if (value) url.searchParams.set(name, value);
          }
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('page', '1');
          const doc = await this.fetchHTML(url, signal);
          const element = doc.querySelector('[data-occasion-products]');
          if (!element) throw new Error('Product metadata unavailable');
          data = JSON.parse(element.textContent);
          const products = [...data.products];
          for (let page = 2; page <= data.pages; page++) {
            url.searchParams.set('page', String(page));
            const pageDoc = await this.fetchHTML(url, signal);
            const pageElement = pageDoc.querySelector('[data-occasion-products]');
            if (!pageElement) throw new Error('Incomplete product metadata');
            products.push(...JSON.parse(pageElement.textContent).products);
          }
          data.products = products;
        }
        const metadata = new Map(data.products.map(product => [String(product.id), product]));
        if (metadata.size !== Number(data.total)) throw new Error('Incomplete product metadata');
        this.metadata = metadata;
        return metadata;
      }

      formatCount(count) {
        return `${count} ${count === 1 ? this.labels.countLabelSingular : this.labels.countLabel}`;
      }

      clearEmptyResults(key) {
        this.controller?.abort();
        if (this.quickNav) this.quickNav.hidden = true;
        this.groupHeadings = [];
        this.runningGrid = null;
        this.runningKey = null;
        this.runningPromise = null;
        this.completeGrid = null;
        this.completeKey = key;
        this.completeSignature = '';
        this.removeAttribute('aria-busy');
        this.retry.hidden = true;
        this.status.textContent = '';
        for (const group of this.labels.groups) {
          const card = this.querySelector(`[data-occasion-group="${group.key}"]`);
          if (card) {
            card.hidden = !this.designMode;
            card.removeAttribute('aria-current');
          }
          const count = this.querySelector(`[data-occasion-count="${group.key}"]`);
          if (count) count.textContent = this.formatCount(0);
        }
        this.hidden = !this.designMode;
      }

      refresh() {
        if (!this.isConnected) return Promise.resolve();
        const grid = this.findGrid();
        const key = this.urlKey();
        if (!grid) {
          if (document.querySelector('results-list .main-collection-grid__empty')) this.clearEmptyResults(key);
          return Promise.resolve();
        }
        if (!this.cards(grid).length) {
          this.clearEmptyResults(key);
          return Promise.resolve();
        }
        if (this.completeGrid === grid && this.completeKey === key && this.completeSignature === this.signature(grid)) {
          return Promise.resolve();
        }
        if (this.runningGrid === grid && this.runningKey === key) return this.runningPromise;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.runningGrid = grid;
        this.runningKey = key;
        this.status.textContent = this.labels.loading;
        this.retry.hidden = true;
        this.setAttribute('aria-busy', 'true');
        if (this.quickNav) this.quickNav.hidden = true;
        this.runningPromise = this.prepare(grid, key, signal).catch(error => {
          if (signal.aborted) return;
          this.status.textContent = this.labels.fallback;
          this.retry.hidden = false;
          console.warn('Occasion navigation:', error.message);
        }).finally(() => {
          if (this.runningGrid === grid && this.runningKey === key) {
            this.runningGrid = null;
            this.removeAttribute('aria-busy');
            this.requestQuickUpdate();
          }
        });
        return this.runningPromise;
      }

      async prepare(grid, key, signal) {
        const metadata = await this.loadMetadata(signal);
        const results = grid.closest('results-list');
        const sectionId = results?.getAttribute('section-id');
        if (!sectionId) throw new Error('Collection section unavailable');
        const pageCount = Math.max(1, Number(grid.dataset.lastPage) || 1);
        const cardPages = new Map();
        for (const card of this.cards(grid)) {
          const page = Number(card.dataset.page) || 1;
          if (!cardPages.has(page)) cardPages.set(page, []);
          cardPages.get(page).push(card);
        }
        for (let page = 1; page <= pageCount; page++) {
          if (cardPages.has(page)) continue;
          const url = new URL(key);
          url.hash = '';
          url.searchParams.set('section_id', sectionId);
          url.searchParams.set('page', String(page));
          const doc = await this.fetchHTML(url, signal);
          const incoming = doc.querySelector('results-list .product-grid[data-testid="product-grid"]');
          if (!incoming) throw new Error('A collection page could not be loaded');
          cardPages.set(page, this.cards(incoming));
        }
        if (signal.aborted || this.findGrid() !== grid || this.urlKey() !== key) {
          this.schedule();
          return;
        }
        const current = new Map(this.cards(grid).map(card => [card.dataset.productId, card]));
        const ordered = new Map();
        for (const [, cards] of [...cardPages.entries()].sort((a, b) => a[0] - b[0])) {
          for (const card of cards) {
            const id = card.dataset.productId;
            if (!ordered.has(id)) ordered.set(id, current.get(id) || card);
          }
        }
        for (const [id, card] of current) if (!ordered.has(id)) ordered.set(id, card);
        const groups = new Map(this.labels.groups.map(group => [group.key, []]));
        groups.set('more', []);
        for (const [id, card] of ordered) {
          const match = this.classifyProduct(metadata.get(id));
          groups.get(match?.key || 'more').push(card);
        }
        results.infinityScrollObserver?.disconnect();
        grid.querySelectorAll(':scope > .pa-occasion-group-heading').forEach(node => node.remove());
        const matchedCount = this.labels.groups.reduce((total, group) => total + groups.get(group.key).length, 0);
        const headings = [...this.labels.groups, { key: 'more', title: this.labels.more }];
        let visibleCategories = 0;
        const nodes = [];
        for (const group of headings) {
          const cards = groups.get(group.key);
          if (group.key === 'more' && (!cards.length || !matchedCount)) continue;
          const categoryCard = this.querySelector(`[data-occasion-group="${group.key}"]`);
          if (categoryCard) {
            categoryCard.hidden = this.hideEmpty && !cards.length && !this.designMode;
            if (!categoryCard.hidden) visibleCategories++;
          }
          if (categoryCard && cards.length) {
            const slot = categoryCard.querySelector('.pa-occasion-nav__image');
            if (slot.querySelector('.pa-occasion-nav__number')) {
              const productImage = cards[0].querySelector('img');
              const imageSource = productImage?.currentSrc || productImage?.getAttribute('src');
              if (imageSource) {
                const image = document.createElement('img');
                image.src = imageSource;
                image.alt = categoryCard.querySelector('.pa-occasion-nav__name').textContent;
                image.loading = 'lazy';
                image.width = 720;
                image.height = 576;
                slot.replaceChildren(image);
              }
            }
          }
          const count = this.querySelector(`[data-occasion-count="${group.key}"]`);
          if (count) count.textContent = this.formatCount(cards.length);
          if (group.key !== 'more' && !cards.length && this.hideEmpty) continue;
          const row = document.createElement('li');
          row.className = 'pa-occasion-group-heading';
          row.dataset.occasionHeading = group.key;
          const heading = document.createElement('h2');
          heading.id = `${this.id}-${group.key}`;
          heading.tabIndex = -1;
          heading.textContent = group.title;
          row.append(heading);
          if (!cards.length) {
            const message = document.createElement('p');
            message.textContent = this.labels.empty;
            row.append(message);
          }
          nodes.push(row, ...cards);

        }
        const retained = new Set(ordered.values());
        for (const card of this.cards(grid)) if (!retained.has(card)) card.remove();
        for (const node of nodes) {
          if (node.isConnected && node.ownerDocument === grid.ownerDocument && typeof grid.moveBefore === 'function') grid.moveBefore(node, null);
          else grid.append(node);
        }
        grid.dataset.lastPage = '1';
        const navigation = this.querySelector('.pa-occasion-nav__cards');
        navigation.style.setProperty('--pa-occasion-columns', String(Math.max(1, Math.min(4, visibleCategories))));
        navigation.style.setProperty('--pa-occasion-mobile-columns', String(Math.max(1, Math.min(2, visibleCategories))));
        this.hidden = !this.designMode && this.hideEmpty && visibleCategories === 0;
        results.classList.add('pa-occasion-ready');
        this.completeGrid = grid;
        this.completeKey = key;
        this.completeSignature = this.signature(grid);
        this.syncQuickNav();
        this.status.textContent = matchedCount ? this.labels.ready : this.labels.fallback;
        if (!this.initialHashHandled) {
          this.initialHashHandled = true;
          const target = document.getElementById(location.hash.slice(1));
          if (target && target.id.startsWith(`${this.id}-`)) this.scrollTo(target, false);
        }
      }

      scrollTo(target, focus = true) {
        let offset = Number(this.dataset.scrollOffset) || 24;
        for (const element of document.querySelectorAll('header-component, sticky-header, header, #header-group, .header-group, [data-sticky-header]')) {
          const box = element.getBoundingClientRect();
          const position = getComputedStyle(element).position;
          if (box.height > 0 && box.top <= 5 && box.bottom > 0 && ['sticky', 'fixed'].includes(position)) {
            offset = Math.max(offset, box.bottom + 24);
          }
        }
        if (this.quickNav) {
          const header = document.querySelector('header-component[sticky]');
          const headerHeight = header?.getBoundingClientRect().height || 0;
          offset = Math.max(offset, headerHeight + 64 + 24);
        }
        target.style.scrollMarginTop = `${offset}px`;
        if (focus) target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }

      async handleClick(event) {
        const retry = event.target.closest('.pa-occasion-nav__retry');
        if (retry) {
          this.completeSignature = null;
          await this.refresh();
          return;
        }
        const link = event.target.closest('[data-occasion-group], [data-occasion-all]');
        if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        await this.refresh();
        if (!this.isConnected) return;
        const key = link.dataset.occasionGroup;
        const target = key ? document.getElementById(`${this.id}-${key}`) : this.findGrid();
        if (!target) {
          const grid = this.findGrid();
          if (grid) this.scrollTo(grid, false);
          return;
        }
        this.setCurrentGroup(key);
        if (key) history.replaceState(history.state, '', `#${target.id}`);
        this.scrollTo(target, Boolean(key));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-party-supplies-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.pa-party-supplies:not([data-pa-motion-initialized])';

    const initialize = (scope = document) => {
      scope.querySelectorAll(selector).forEach((section) => {
        section.dataset.paMotionInitialized = 'true';

        const items = [
          section.querySelector('.pa-party-supplies__header'),
          section.querySelector('.pa-party-supplies__media'),
          section.querySelector('.pa-party-supplies__copy'),
          ...section.querySelectorAll('.pa-party-supplies__row'),
          section.querySelector('.pa-party-supplies__button')
        ].filter(Boolean);

        items.forEach((item, index) => {
          item.style.setProperty('--pa-motion-delay', `${Math.min(index * 80, 480)}ms`);
        });

        section.classList.add('pa-motion-ready');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('pa-motion-visible'));
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('pa-motion-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

        items.forEach((item) => observer.observe(item));
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    

class ProductCardVariants extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.variants = this.readVariants();
    this.optionCount = parseInt(this.dataset.optionCount || '1', 10);
    this.selections = new Array(this.optionCount).fill(null);

    this.buttons = Array.from(this.querySelectorAll('[data-option-value]'));
    this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
    this.atcButton = this.querySelector('[data-atc]');
    this.priceEl = this.querySelector('[data-selected-price]');
    this.errorEl = this.querySelector('[data-atc-error]');

    /* Theme ka apna price element (card ke andar) — variant ke sath update hoga */
    this.cardPriceEl = this.resolveCardPriceEl();
    this.cardPriceOriginal = this.cardPriceEl ? this.cardPriceEl.innerHTML : null;

    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.onSelect(button);
      });
    });

    this.moreButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleMore(button);
      });
    });

    if (this.atcButton) {
      this.atcButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }

    this.preselect();
    this.update();
  }

  readVariants() {
    const script = this.querySelector('[data-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  /* Kya is option position ke liye koi clickable button maujood hai? */
  hasButtonsAt(position) {
    return this.buttons.some((b) => parseInt(b.dataset.optionPosition, 10) === position + 1);
  }

  /* Extra variants ko wahin expand / collapse karta hai */
  toggleMore(button) {
    const row = button.closest('[data-option-row]');
    if (!row) return;

    const expanded = row.dataset.expanded === 'true';
    const hidden = Array.from(row.querySelectorAll('[data-extra="true"]'));

    hidden.forEach((item) => {
      item.dataset.hidden = expanded ? 'true' : 'false';
    });

    row.dataset.expanded = expanded ? 'false' : 'true';
    button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  }

  /*
    Pehla available variant by default select ho jata hai.
    Agar kisi option ke liye koi swatch/pill render hi nahi hui
    (jaise "Default Title" wale single-variant products),
    to us position ki value seedha variant se le li jati hai —
    is tarah Add to cart shuru se hi kaam karta hai.
  */
  preselect() {
    const first = this.variants.find((v) => v.available) || this.variants[0];
    if (!first) return;

    for (let index = 0; index < this.optionCount; index++) {
      const value = first.options[index];
      if (value === undefined) continue;

      if (!this.hasButtonsAt(index)) {
        this.selections[index] = value;
        continue;
      }

      const exists = this.buttons.some(
        (b) => parseInt(b.dataset.optionPosition, 10) === index + 1 && b.dataset.optionValue === value
      );
      if (exists) this.selections[index] = value;
    }
  }

  onSelect(button) {
    const position = parseInt(button.dataset.optionPosition, 10) - 1;
    const value = button.dataset.optionValue;

    this.selections[position] = this.selections[position] === value ? null : value;
    this.update(true);
  }

  matchedVariant() {
    /* Single variant product: seedha wahi variant */
    if (this.variants.length === 1) return this.variants[0];

    if (this.selections.some((s) => s === null)) return null;

    return this.variants.find((v) =>
      v.options.every((opt, i) => opt === this.selections[i])
    ) || null;
  }

  valueIsAvailable(position, value) {
    return this.variants.some((v) => {
      if (!v.available) return false;
      if (v.options[position] !== value) return false;
      return this.selections.every((sel, i) => i === position || !sel || v.options[i] === sel);
    });
  }

  updateSelectedOptionLabels() {
    this.querySelectorAll('[data-option-row]').forEach((row) => {
      const label = row.querySelector('.card-variant-options__label');
      if (!label) return;
      const selected = row.querySelector('[data-option-value][aria-pressed="true"]');
      const optionName = label.dataset.optionName || label.textContent.trim();
      label.dataset.optionName = optionName;
      label.textContent = optionName + (selected ? ': ' + selected.dataset.optionValue : '');
    });
  }

  update(changeImage = false) {
    this.buttons.forEach((button) => {
      const position = parseInt(button.dataset.optionPosition, 10) - 1;
      const value = button.dataset.optionValue;
      const selected = this.selections[position] === value;

      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.dataset.unavailable = this.valueIsAvailable(position, value) ? 'false' : 'true';

      /* Agar selected value hidden hai to us row ko khol do */
      if (selected && button.dataset.hidden === 'true') {
        const row = button.closest('[data-option-row]');
        const moreButton = row ? row.querySelector('[data-more]') : null;
        if (moreButton) this.toggleMore(moreButton);
      }
    });

    this.updateSelectedOptionLabels();

    const variant = this.matchedVariant();

    if (this.priceEl) {
      this.priceEl.innerHTML = variant ? variant.price : '';
    }

    /* Card ki asal price ab selected variant ki price dikhati hai */
    this.updateCardPrice(variant);

    if (changeImage && variant && variant.image && this.buttons.length) this.swapImage(variant.image);

    if (this.atcButton) {
      const labels = {
        idle: this.atcButton.dataset.labelIdle,
        soldOut: this.atcButton.dataset.labelSoldOut,
        choose: this.atcButton.dataset.labelChoose,
      };

      if (!variant) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = labels.choose;
      } else if (!variant.available) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = labels.soldOut;
      } else {
        this.atcButton.disabled = false;
        this.atcButton.textContent = labels.idle;
      }
    }

    this.hideError();
  }

  /* =========================================================
     SELECTED VARIANT PRICE

     Theme ka price block har theme me alag markup deta hai,
     is liye card ke andar sab se pehla price-jaisa element
     dhoond kar usi ke andar likhte hain. Original markup
     yaad rakha jata hai taake selection hatne par wapas aa sake.
  ========================================================= */

  resolveCardPriceEl() {
    const card = this.closest('.resource-list__item') || this.parentElement;
    if (!card) return null;

    const selectors = [
      '[data-testid="price"]',
      'product-price',
      '.price',
      '.product-price',
      '[class*="price"]',
    ];

    for (const selector of selectors) {
      const found = Array.from(card.querySelectorAll(selector)).find((el) => {
        if (el === this || this.contains(el)) return false;
        if (el.tagName === 'SCRIPT' || el.tagName === 'TEMPLATE' || el.tagName === 'STYLE') return false;
        return true;
      });

      if (found) return found;
    }

    return null;
  }

  updateCardPrice(variant) {
    if (this.dataset.syncPrice === 'false') return;

    if (!this.cardPriceEl) {
      this.cardPriceEl = this.resolveCardPriceEl();
      if (!this.cardPriceEl) return;
      this.cardPriceOriginal = this.cardPriceEl.innerHTML;
    }

    /* Koi mukammal selection nahi — theme ki original price wapas */
    if (!variant) {
      if (this.cardPriceOriginal != null) this.cardPriceEl.innerHTML = this.cardPriceOriginal;
      return;
    }

    const onSale =
      variant.compare_at_price &&
      Number(variant.compare_at_price_raw) > Number(variant.price_raw);

    let html =
      '<span class="card-price__current' +
      (onSale ? ' card-price__current--sale' : '') +
      '">' +
      variant.price +
      '</span>';

    if (onSale) {
      html += '<span class="card-price__compare">' + variant.compare_at_price + '</span>';
    }

    this.cardPriceEl.innerHTML = html;
  }

  swapImage(url) {
    if (this.dataset.swapImage !== 'true') return;
    const card = this.closest('.resource-list__item');
    if (!card) return;
    const img = card.querySelector('img');
    if (!img) return;
    try {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    } catch (e) {
      /* noop */
    }
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.dataset.visible = 'true';
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.dataset.visible = 'false';
  }

  async addToCart() {
    const variant = this.matchedVariant();
    if (!variant || !variant.available || !this.atcButton) return;

    const button = this.atcButton;
    const idleLabel = button.dataset.labelIdle;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    button.dataset.state = 'loading';
    button.textContent = button.dataset.labelLoading;
    this.hideError();

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      button.dataset.state = 'done';
      button.textContent = button.dataset.labelAdded;

      /* Cart drawer / cart count refresh */
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'product-card' } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));

      if (this.dataset.afterAdd === 'cart') {
        window.location.href = root + 'cart';
        return;
      }

      if (this.dataset.afterAdd === 'drawer') {
        const drawer = document.querySelector('cart-drawer, cart-drawer-component, #cart-drawer');
        if (drawer) {
          if (typeof drawer.open === 'function') drawer.open();
          else if (typeof drawer.showModal === 'function') drawer.showModal();
        }
      }

      setTimeout(() => {
        button.dataset.state = 'idle';
        button.textContent = idleLabel;
      }, 1800);
    } catch (error) {
      button.dataset.state = 'idle';
      button.textContent = idleLabel;
      this.showError(error.message || 'Something went wrong');
    }
  }
}

if (!customElements.get('product-card-variants')) {
  customElements.define('product-card-variants', ProductCardVariants);
}


/* =========================================================
   MOVE HEADER BUTTON BELOW PRODUCT CARDS + RENAME VIEW ALL
========================================================= */

function placeProductListViewAllButtons(root = document) {
  const sections = [];

  if (root && root.matches && root.matches('.section-resource-list')) {
    sections.push(root);
  }

  if (root && root.querySelectorAll) {
    sections.push(...root.querySelectorAll('.section-resource-list'));
  }

  [...new Set(sections)].forEach((sectionEl) => {
    const header = sectionEl.querySelector('.section-resource-list__header');
    const slot = sectionEl.querySelector('[data-view-all-slot]');

    if (!header || !slot) return;

    /*
      _product-list-button can render with different theme button classes.
      Prefer an element that looks like a button or contains the existing
      SHOP NOW / VIEW ALL text. The collection title is a heading, so it is
      not selected here.
    */
    const candidates = Array.from(header.querySelectorAll('a, button'));

    let viewAllButton = candidates.find((el) => {
      const label = (el.textContent || '').trim();
      const className = typeof el.className === 'string' ? el.className : '';

      return (
        /^(shop\s*now|view\s*all)$/i.test(label) ||
        /button/i.test(className)
      );
    });

    /* Fallback: use the last non-heading interactive element in the header. */
    if (!viewAllButton && candidates.length) {
      viewAllButton = candidates[candidates.length - 1];
    }

    if (!viewAllButton) return;

    /* Already moved — just keep the requested text. */
    if (slot.contains(viewAllButton)) {
      viewAllButton.textContent = 'VIEW ALL';
      viewAllButton.setAttribute('aria-label', 'View all');
      viewAllButton.classList.add('section-resource-list__view-all-button');
      return;
    }

    const oldParent = viewAllButton.parentElement;

    viewAllButton.textContent = 'VIEW ALL';
    viewAllButton.setAttribute('aria-label', 'View all');
    viewAllButton.classList.add('section-resource-list__view-all-button');

    slot.appendChild(viewAllButton);

    /* Remove only wrappers that became completely empty after the move. */
    let wrapper = oldParent;
    while (wrapper && wrapper !== header) {
      const hasMeaningfulContent = wrapper.querySelector(
        'a, button, h1, h2, h3, h4, h5, h6, img, svg, video, input, select, textarea'
      );
      const hasText = (wrapper.textContent || '').trim().length > 0;

      if (!hasMeaningfulContent && !hasText) {
        const nextWrapper = wrapper.parentElement;
        wrapper.remove();
        wrapper = nextWrapper;
      } else {
        break;
      }
    }
  });
}

function initProductListViewAllButtons() {
  placeProductListViewAllButtons(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductListViewAllButtons, { once: true });
} else {
  initProductListViewAllButtons();
}

/* Shopify Theme Editor support. */
document.addEventListener('shopify:section:load', (event) => {
  placeProductListViewAllButtons(event.target || document);
});

document.addEventListener('shopify:block:select', () => {
  requestAnimationFrame(() => placeProductListViewAllButtons(document));
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class RecommendationCardVariants extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.variants = this.readVariants();
      this.optionCount = Math.max(parseInt(this.dataset.optionCount || '1', 10), 1);
      this.buttons = Array.from(this.querySelectorAll('[data-option-value]'));
      this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
      this.form = this.querySelector('form.card-atc');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.atcButton = this.querySelector('[data-atc]');
      this.fallbackPriceEl = this.querySelector('[data-selected-price]');
      this.errorEl = this.querySelector('[data-atc-error]');
      this.cardPriceEl = this.resolveCardPriceEl();

      const initialId = Number(this.dataset.initialVariantId || 0);
      this.currentVariant =
        this.variants.find((variant) => Number(variant.id) === initialId) ||
        this.variants.find((variant) => variant.available) ||
        this.variants[0] ||
        null;

      this.selections = this.currentVariant
        ? this.currentVariant.options.slice(0, this.optionCount)
        : new Array(this.optionCount).fill(null);

      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.selectOption(button);
        });
      });

      this.moreButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleMore(button);
        });
      });

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.addToCart();
        });
      }

      this.update();
    }

    readVariants() {
      const script = this.querySelector('[data-variants]');
      if (!script) return [];

      try {
        const variants = JSON.parse(script.textContent);
        return Array.isArray(variants) ? variants : [];
      } catch (error) {
        return [];
      }
    }

    toggleMore(button) {
      const row = button.closest('[data-option-row]');
      if (!row) return;

      const expanded = row.dataset.expanded === 'true';
      row.querySelectorAll('[data-extra="true"]').forEach((item) => {
        item.dataset.hidden = expanded ? 'true' : 'false';
      });

      row.dataset.expanded = expanded ? 'false' : 'true';
      button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }

    selectOption(button) {
      const position = Number(button.dataset.optionPosition) - 1;
      const value = button.dataset.optionValue;
      if (position < 0 || position >= this.optionCount) return;

      const wantedSelections = this.selections.slice();
      wantedSelections[position] = value;

      let nextVariant = this.findVariant(wantedSelections);
      if (!nextVariant) nextVariant = this.bestVariantForValue(position, value);

      if (nextVariant) {
        this.currentVariant = nextVariant;
        this.selections = nextVariant.options.slice(0, this.optionCount);
      } else {
        this.currentVariant = null;
        this.selections = wantedSelections;
      }

      this.update();
    }

    findVariant(selections) {
      if (!Array.isArray(selections) || selections.some((value) => value == null)) return null;

      return this.variants.find((variant) =>
        variant.options.every((option, index) => option === selections[index])
      ) || null;
    }

    matchedVariant() {
      return this.findVariant(this.selections);
    }

    bestVariantForValue(position, value) {
      const candidates = this.variants.filter((variant) => variant.options[position] === value);
      if (!candidates.length) return null;

      return candidates
        .map((variant, index) => ({
          variant,
          index,
          matches: variant.options.reduce((score, option, optionIndex) => {
            if (optionIndex === position) return score;
            return score + (option === this.selections[optionIndex] ? 1 : 0);
          }, 0),
        }))
        .sort((a, b) => {
          if (a.variant.available !== b.variant.available) return a.variant.available ? -1 : 1;
          if (a.matches !== b.matches) return b.matches - a.matches;
          return a.index - b.index;
        })[0].variant;
    }

    valueIsAvailable(position, value) {
      const wantedSelections = this.selections.slice();
      wantedSelections[position] = value;
      const exactVariant = this.findVariant(wantedSelections);

      if (exactVariant) return Boolean(exactVariant.available);

      return this.variants.some(
        (variant) => variant.available && variant.options[position] === value
      );
    }

    update() {
      const variant = this.matchedVariant();
      this.currentVariant = variant;

      this.buttons.forEach((button) => {
        const position = Number(button.dataset.optionPosition) - 1;
        const value = button.dataset.optionValue;
        const selected = this.selections[position] === value;
        const available = this.valueIsAvailable(position, value);

        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.dataset.unavailable = available ? 'false' : 'true';

        if (selected && button.dataset.hidden === 'true') {
          const row = button.closest('[data-option-row]');
          const moreButton = row ? row.querySelector('[data-more]') : null;
          if (moreButton && row.dataset.expanded !== 'true') this.toggleMore(moreButton);
        }
      });

      if (this.variantIdInput) {
        this.variantIdInput.value = variant ? String(variant.id) : '';
        this.variantIdInput.disabled = !variant;
      }

      this.updatePrice(variant);
      this.updateImage(variant);
      this.updateButton(variant);
      this.hideError();
    }

    resolveCardPriceEl() {
      const card = this.closest('.resource-list__item');
      if (!card) return null;

      const selectors = [
        'product-price',
        '[data-testid="price"]',
        '[data-product-price]',
        '.product-price',
        '.price',
        '.price__container',
      ];

      for (const selector of selectors) {
        const element = Array.from(card.querySelectorAll(selector)).find((candidate) => {
          if (candidate === this || this.contains(candidate)) return false;
          return !candidate.closest('template, script, style');
        });

        if (element) return element;
      }

      return null;
    }

    createPriceContent(variant) {
      const fragment = document.createDocumentFragment();
      if (!variant) return fragment;

      const onSale =
        variant.compare_at_price &&
        Number(variant.compare_at_price_raw) > Number(variant.price_raw);

      const currentPrice = document.createElement('span');
      currentPrice.className = 'card-price__current' + (onSale ? ' card-price__current--sale' : '');
      currentPrice.innerHTML = variant.price;
      fragment.appendChild(currentPrice);

      if (onSale) {
        const comparePrice = document.createElement('s');
        comparePrice.className = 'card-price__compare';
        comparePrice.innerHTML = variant.compare_at_price;
        fragment.appendChild(comparePrice);
      }

      return fragment;
    }

    updatePrice(variant) {
      if (!this.cardPriceEl) this.cardPriceEl = this.resolveCardPriceEl();

      const target = this.cardPriceEl || this.fallbackPriceEl;
      if (!target) return;

      if (this.fallbackPriceEl) {
        this.fallbackPriceEl.hidden = Boolean(this.cardPriceEl);
      }

      target.replaceChildren(this.createPriceContent(variant));
      target.setAttribute('aria-live', 'polite');
      target.dataset.selectedVariantPrice = variant ? String(variant.id) : '';
    }

    updateImage(variant) {
      if (this.dataset.swapImage !== 'true' || !variant || !variant.image) return;

      const card = this.closest('.resource-list__item');
      const image = card ? card.querySelector('img') : null;
      if (!image || image.src === variant.image) return;

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = variant.image;
    }

    updateButton(variant) {
      if (!this.atcButton || this.atcButton.dataset.state === 'loading') return;

      if (!variant) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = this.atcButton.dataset.labelChoose;
      } else if (!variant.available) {
        this.atcButton.disabled = true;
        this.atcButton.textContent = this.atcButton.dataset.labelSoldOut;
      } else {
        this.atcButton.disabled = false;
        this.atcButton.textContent = this.atcButton.dataset.labelIdle;
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.dataset.visible = 'true';
    }

    hideError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.dataset.visible = 'false';
    }

    cartRoutes() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const configuredAddRoute = window.routes && window.routes.cart_add_url;
      const addRoute = configuredAddRoute || root + 'cart/add';

      return {
        root,
        add: addRoute.endsWith('.js') ? addRoute : addRoute + '.js',
        cart: root + 'cart',
      };
    }

    announceCartChange(item, variant) {
      const detail = {
        source: 'recommendation-card-variants',
        product: item,
        variantId: variant.id,
      };

      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail }));
    }

    openCartDrawer() {
      const drawer = document.querySelector(
        'cart-drawer-component, cart-drawer, #CartDrawer, #cart-drawer'
      );
      if (!drawer) return false;

      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
        return true;
      }

      const dialog = drawer.matches('dialog') ? drawer : drawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        return true;
      }

      return false;
    }

    async addToCart() {
      const variant = this.matchedVariant();
      if (!variant || !variant.available || !this.atcButton || !this.form) return;
      if (this.atcButton.dataset.state === 'loading') return;

      const routes = this.cartRoutes();
      const formData = new FormData(this.form);
      formData.set('id', String(variant.id));
      formData.set('quantity', String(formData.get('quantity') || 1));

      this.atcButton.dataset.state = 'loading';
      this.atcButton.disabled = true;
      this.atcButton.textContent = this.atcButton.dataset.labelLoading;
      this.hideError();

      try {
        const response = await fetch(routes.add, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.description || result.message || 'Could not add this variant to cart.');
        }

        this.atcButton.dataset.state = 'done';
        this.atcButton.textContent = this.atcButton.dataset.labelAdded;
        this.announceCartChange(result, variant);

        if (this.dataset.afterAdd === 'cart') {
          window.location.assign(routes.cart);
          return;
        }

        if (this.dataset.afterAdd === 'drawer') {
          requestAnimationFrame(() => this.openCartDrawer());
        }

        window.setTimeout(() => {
          this.atcButton.dataset.state = 'idle';
          this.updateButton(this.matchedVariant());
        }, 1800);
      } catch (error) {
        this.atcButton.dataset.state = 'idle';
        this.updateButton(this.matchedVariant());
        this.showError(error.message || 'Something went wrong. Please try again.');
      }
    }
  }

  if (!customElements.get('recommendation-card-variants')) {
    customElements.define('recommendation-card-variants', RecommendationCardVariants);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  class SearchProductCardVariants extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.variants = this.readVariants();
      this.optionCount = Number.parseInt(this.dataset.optionCount || '1', 10);
      this.selections = new Array(this.optionCount).fill(null);

      this.optionButtons = Array.from(this.querySelectorAll('[data-option-value]'));
      this.moreButtons = Array.from(this.querySelectorAll('[data-more]'));
      this.addButton = this.querySelector('[data-atc]');
      this.extraPriceElement = this.querySelector('[data-selected-price]');
      this.errorElement = this.querySelector('[data-atc-error]');

      this.cardPriceElement = this.resolveCardPriceElement();
      this.originalCardPrice = this.cardPriceElement ? this.cardPriceElement.innerHTML : null;

      this.optionButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.selectOption(button);
        });
      });

      this.moreButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleMore(button);
        });
      });

      if (this.addButton) {
        this.addButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.addToCart();
        });
      }

      this.preselectFirstAvailableVariant();
      this.update();
    }

    readVariants() {
      const dataElement = this.querySelector('[data-variants]');
      if (!dataElement) return [];

      try {
        return JSON.parse(dataElement.textContent) || [];
      } catch (error) {
        return [];
      }
    }

    getCard() {
      return this.closest('.product-grid__item') || this.parentElement;
    }

    hasButtonsAt(position) {
      return this.optionButtons.some(
        (button) => Number.parseInt(button.dataset.optionPosition, 10) === position + 1
      );
    }

    toggleMore(button) {
      const row = button.closest('[data-option-row]');
      if (!row) return;

      const isExpanded = row.dataset.expanded === 'true';
      const extraItems = Array.from(row.querySelectorAll('[data-extra="true"]'));

      extraItems.forEach((item) => {
        item.dataset.hidden = isExpanded ? 'true' : 'false';
      });

      row.dataset.expanded = isExpanded ? 'false' : 'true';
      button.textContent = isExpanded ? button.dataset.labelMore : button.dataset.labelLess;
      button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    }

    preselectFirstAvailableVariant() {
      const firstVariant = this.variants.find((variant) => variant.available) || this.variants[0];
      if (!firstVariant) return;

      for (let index = 0; index < this.optionCount; index += 1) {
        const optionValue = firstVariant.options[index];
        if (optionValue === undefined) continue;

        if (!this.hasButtonsAt(index)) {
          this.selections[index] = optionValue;
          continue;
        }

        const buttonExists = this.optionButtons.some(
          (button) =>
            Number.parseInt(button.dataset.optionPosition, 10) === index + 1 &&
            button.dataset.optionValue === optionValue
        );

        if (buttonExists) this.selections[index] = optionValue;
      }
    }

    selectOption(button) {
      const position = Number.parseInt(button.dataset.optionPosition, 10) - 1;
      const value = button.dataset.optionValue;

      this.selections[position] = this.selections[position] === value ? null : value;
      this.update();
    }

    getMatchedVariant() {
      if (this.variants.length === 1) return this.variants[0];
      if (this.selections.some((selection) => selection === null)) return null;

      return (
        this.variants.find((variant) =>
          variant.options.every((option, index) => option === this.selections[index])
        ) || null
      );
    }

    valueIsAvailable(position, value) {
      return this.variants.some((variant) => {
        if (!variant.available || variant.options[position] !== value) return false;

        return this.selections.every(
          (selection, index) =>
            index === position || !selection || variant.options[index] === selection
        );
      });
    }

    update() {
      this.optionButtons.forEach((button) => {
        const position = Number.parseInt(button.dataset.optionPosition, 10) - 1;
        const value = button.dataset.optionValue;
        const isSelected = this.selections[position] === value;

        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        button.dataset.unavailable = this.valueIsAvailable(position, value) ? 'false' : 'true';

        if (isSelected && button.dataset.hidden === 'true') {
          const row = button.closest('[data-option-row]');
          const moreButton = row ? row.querySelector('[data-more]') : null;
          if (moreButton) this.toggleMore(moreButton);
        }
      });

      const variant = this.getMatchedVariant();

      if (this.extraPriceElement) {
        this.extraPriceElement.innerHTML = variant ? variant.price : '';
      }

      this.updateCardPrice(variant);

      if (variant && variant.image && this.optionButtons.length > 0) {
        this.swapCardImage(variant.image);
      }

      this.updateAddButton(variant);
      this.hideError();
    }

    updateAddButton(variant) {
      if (!this.addButton) return;

      if (!variant) {
        this.addButton.disabled = true;
        this.addButton.textContent = this.addButton.dataset.labelChoose;
        return;
      }

      if (!variant.available) {
        this.addButton.disabled = true;
        this.addButton.textContent = this.addButton.dataset.labelSoldOut;
        return;
      }

      this.addButton.disabled = false;
      this.addButton.textContent = this.addButton.dataset.labelIdle;
    }

    resolveCardPriceElement() {
      const card = this.getCard();
      if (!card) return null;

      const selectors = [
        '[data-testid="price"]',
        'product-price',
        '.price',
        '.product-price',
        '[class*="price"]',
      ];

      for (const selector of selectors) {
        const element = Array.from(card.querySelectorAll(selector)).find((candidate) => {
          if (candidate === this || this.contains(candidate)) return false;
          if (['SCRIPT', 'TEMPLATE', 'STYLE'].includes(candidate.tagName)) return false;
          return true;
        });

        if (element) return element;
      }

      return null;
    }

    updateCardPrice(variant) {
      if (this.dataset.syncPrice !== 'true') return;

      if (!this.cardPriceElement) {
        this.cardPriceElement = this.resolveCardPriceElement();
        if (!this.cardPriceElement) return;
        this.originalCardPrice = this.cardPriceElement.innerHTML;
      }

      if (!variant) {
        if (this.originalCardPrice !== null) {
          this.cardPriceElement.innerHTML = this.originalCardPrice;
        }
        return;
      }

      const isOnSale =
        variant.compare_at_price &&
        Number(variant.compare_at_price_raw) > Number(variant.price_raw);

      let priceMarkup =
        '<span class="search-card-price__current' +
        (isOnSale ? ' search-card-price__current--sale' : '') +
        '">' +
        variant.price +
        '</span>';

      if (isOnSale) {
        priceMarkup +=
          '<span class="search-card-price__compare">' + variant.compare_at_price + '</span>';
      }

      this.cardPriceElement.innerHTML = priceMarkup;
    }

    swapCardImage(url) {
      if (this.dataset.swapImage !== 'true') return;

      const card = this.getCard();
      if (!card) return;

      const imageSelectors = [
        '.product-card__image img',
        '[data-product-card-image] img',
        'product-card img',
      ];

      let image = null;

      for (const selector of imageSelectors) {
        image = card.querySelector(selector);
        if (image && !this.contains(image)) break;
        image = null;
      }

      if (!image) {
        image = Array.from(card.querySelectorAll('img')).find(
          (candidate) => !this.contains(candidate)
        );
      }

      if (!image) return;

      const picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('srcset');
          source.removeAttribute('sizes');
        });
      }

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url;
    }

    showError(message) {
      if (!this.errorElement) return;
      this.errorElement.textContent = message;
      this.errorElement.dataset.visible = 'true';
    }

    hideError() {
      if (!this.errorElement) return;
      this.errorElement.textContent = '';
      this.errorElement.dataset.visible = 'false';
    }

    async addToCart() {
      const variant = this.getMatchedVariant();
      if (!variant || !variant.available || !this.addButton) return;

      const button = this.addButton;
      const idleLabel = button.dataset.labelIdle;
      const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      button.disabled = true;
      button.dataset.state = 'loading';
      button.textContent = button.dataset.labelLoading;
      this.hideError();

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1,
              },
            ],
          }),
        });

        const responseData = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(
            responseData.description || responseData.message || 'Could not add to cart'
          );
        }

        button.dataset.state = 'done';
        button.textContent = button.dataset.labelAdded;

        const eventDetail = {
          source: 'search-product-card',
          productId: this.dataset.productId,
          variantId: variant.id,
          resource: responseData,
        };

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: eventDetail,
          })
        );
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: eventDetail,
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: eventDetail,
          })
        );

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = root + 'cart';
          return;
        }

        if (this.dataset.afterAdd === 'drawer') {
          const drawer = document.querySelector(
            'cart-drawer, cart-drawer-component, #cart-drawer'
          );

          if (drawer) {
            if (typeof drawer.open === 'function') {
              drawer.open();
            } else if (typeof drawer.showModal === 'function') {
              drawer.showModal();
            }
          }
        }

        window.setTimeout(() => {
          button.disabled = false;
          button.dataset.state = 'idle';
          button.textContent = idleLabel;
        }, 1800);
      } catch (error) {
        button.disabled = false;
        button.dataset.state = 'idle';
        button.textContent = idleLabel;
        this.showError(error.message || 'Something went wrong');
      }
    }
  }

  if (!customElements.get('search-product-card-variants')) {
    customElements.define('search-product-card-variants', SearchProductCardVariants);
  }

  } catch(e) { console.error(e); }
})();
})();
